import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import CityPage from "@/pages/CityPage";
import CitySelector from "@/pages/CitySelector";
import DistrictPage from "@/pages/DistrictPage";
import ReviewsPage from "@/pages/ReviewsPage";
import PressPage from "@/pages/PressPage";
import AdminPage from "@/pages/AdminPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import BlogPage from "@/pages/BlogPage";
import BlogArticlePage from "@/pages/BlogArticlePage";
import WeddingsHubPage from "@/pages/WeddingsHubPage";
import WeddingsPage from "@/pages/WeddingsPage";
import YachtsHubPage from "@/pages/YachtsHubPage";
import LegalPage from "@/pages/LegalPage";
import HotelDeliveryPage from "@/pages/HotelDeliveryPage";
import { bangkokHotelContent, BANGKOK_HOTEL_PRODUCT_IDS, BANGKOK_HOTEL_PRODUCT_NAMES } from "@/data/bangkokHotelContent";
import { barcelonaHotelContent, BARCELONA_HOTEL_PRODUCT_NAMES } from "@/data/barcelonaHotelContent";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App min-h-screen bg-white" data-testid="main-app">
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<CitySelector />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogArticlePage />} />
          <Route path="/weddings" element={<WeddingsHubPage />} />
          <Route path="/weddings/:citySlug" element={<WeddingsPage />} />
          <Route path="/yachts" element={<YachtsHubPage />} />
          <Route path="/legal/:type" element={<LegalPage />} />
          <Route path="/terms" element={<Navigate to="/legal/terms" replace />} />
          <Route path="/privacy" element={<Navigate to="/legal/privacy" replace />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/istanbul/hotel-flower-delivery" element={<HotelDeliveryPage />} />
          <Route
            path="/bangkok/hotel-flower-delivery"
            element={
              <HotelDeliveryPage
                citySlug="bangkok"
                path="/bangkok/hotel-flower-delivery"
                content={bangkokHotelContent}
                productIds={BANGKOK_HOTEL_PRODUCT_IDS}
                productNames={BANGKOK_HOTEL_PRODUCT_NAMES}
              />
            }
          />
          <Route
            path="/barcelona/hotel-flower-delivery"
            element={
              <HotelDeliveryPage
                citySlug="barcelona"
                path="/barcelona/hotel-flower-delivery"
                content={barcelonaHotelContent}
                productNames={BARCELONA_HOTEL_PRODUCT_NAMES}
              />
            }
          />
          <Route path="/:citySlug" element={<CityPage />} />
          <Route path="/press-about-us" element={<PressPage />} />
          <Route path="/:citySlug/reviews" element={<ReviewsPage />} />
          <Route path="/:citySlug/:districtSlug" element={<DistrictPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
